<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-arrow-fall-square`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M44 4a2 2 0 012 2v36a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h40zm-2 4H6v32h36V8zm-16.154 4c.34 0 .616.28.616.623v12.78h4.615c.045 0 .087.007.13.014.05.008.087.017.123.028.03.01.06.018.089.03l.044.022c.03.014.06.025.089.044a.973.973 0 01.427.653c.012.076.017.125.018.175l.003.036c0 .02-.004.04-.006.06l-.006.066a1.04 1.04 0 01-.174.471l-6.928 8.382c-.184.347-.543.674-.886.607-.343.067-.702-.26-.886-.607l-6.928-8.382a1.043 1.043 0 01-.174-.47l-.006-.066c-.002-.021-.006-.04-.006-.061l.003-.036c.001-.05.006-.099.014-.148.053-.292.2-.535.431-.68.029-.019.06-.03.089-.044.015-.007.029-.015.044-.021a.938.938 0 01.2-.058c.055-.008.097-.015.142-.015h4.616v-12.78a.62.62 0 01.615-.623h3.692z"/></svg>
</template>
<script>

export default {
  name: 'IconArrowFallSquare',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
